function toArrayComparable(array) {
  return JSON.stringify(array.sort());
}

export function areArraysEqual(array1, array2) {
  return toArrayComparable(array1) === toArrayComparable(array2);
}

export function areArrays(...arrays) {
  return arrays.every(a => a instanceof Array);
}
